// extracted by mini-css-extract-plugin
export var backgroundImage = "RegisterForm-module--backgroundImage--7c115";
export var btn = "RegisterForm-module--btn--09588";
export var columnWrapper = "RegisterForm-module--columnWrapper--fb4ac";
export var form = "RegisterForm-module--form--426e4";
export var formSubmit = "RegisterForm-module--formSubmit--1874f";
export var formSubmitWrapper = "RegisterForm-module--formSubmitWrapper--de022";
export var info = "RegisterForm-module--info--347ab";
export var message = "RegisterForm-module--message--ef8ee";
export var notes = "RegisterForm-module--notes--81445";
export var options = "RegisterForm-module--options--379fc";
export var optionsWrapper = "RegisterForm-module--optionsWrapper--683a7";
export var personalInfo = "RegisterForm-module--personalInfo--705e6";
export var submitBtn = "RegisterForm-module--submitBtn--f9393";
export var submitSection = "RegisterForm-module--submitSection--6aa0a";
export var validation = "RegisterForm-module--validation--8f20e";
export var wrapper = "RegisterForm-module--wrapper--75136";